import Vue from 'vue';



export default Vue.extend({

  name: 'ClearButton',

  methods: {
    clear(): void {
      this.$emit('onClick');
    }
  }



});
